import * as React from 'react';
import { Box, AppBar, Toolbar, IconButton, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from './Drawer';
import CargoVistaLogo from './CargoVistaLogo';
import GlobalProjectSearch from '../projects/GlobalProjectSearch';

type PropsWithChildren<P> = P & { children?: React.ReactNode };

type IProps = PropsWithChildren<{ fullWidth?: boolean }>;

const Layout: React.FC<IProps> = (props) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        maxWidth: '100%',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        textAlign: 'left',
      }}
    >
      {isMobile && (
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            zIndex: (appTheme) => appTheme.zIndex.drawer + 1,
            bgcolor: 'background.paper',
            color: 'text.primary',
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Toolbar sx={{ minHeight: '56px', px: 2 }}>
            <CargoVistaLogo />
            <Box sx={{ flex: 1 }} />
            <IconButton
              size="large"
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      )}

      <Box display="flex" flexDirection="row" sx={{ flex: 1, overflow: 'hidden', mt: isMobile ? '56px' : 0 }}>
        <Drawer mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />

        <Box
          component="main"
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: 'auto',
            bgcolor: 'grey.50',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ minHeight: 56, px: { xs: 2, sm: 3 }, py: 1, boxSizing: 'border-box', bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <GlobalProjectSearch />
          </Box>
          <Box
            sx={{
              mx: 'auto',
              width: '100%',
              maxWidth: props.fullWidth ? 'none' : 1400,
              p: { xs: '16px', sm: '24px' },
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              boxSizing: 'border-box',
            }}
          >
            {props.children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
